import { render, staticRenderFns } from "./M60SVitalSigns.vue?vue&type=template&id=74a597cc&scoped=true&"
import script from "./M60SVitalSigns.vue?vue&type=script&lang=js&"
export * from "./M60SVitalSigns.vue?vue&type=script&lang=js&"
import style0 from "./M60SVitalSigns.vue?vue&type=style&index=0&id=74a597cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a597cc",
  null
  
)

export default component.exports